import React, { useState, useMemo } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { editUserTester } from "../../redux/tester/slice";
import {
  DefaultButton,
  DefaultPrimaryButton,
  InputWithLabel,
} from "../../components/micro";

const EditUserTester = ({ onClose, getUserfatch }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = useMemo(
    () => ({
      email: "",
    }),
    []
  );

  const validationSchema = Yup.object().shape({
    email: Yup.string().trim().nullable().required("Please enter Email"),
  });

  return (
    <div className="modal" onClick={onClose}>
      <div
        className="bg-white px-8 drop-shadow-lg rounded-lg w-full max-w-md  py-8  sm:mx-auto  relative"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-2xl font-semibold mb-6 text-center">
          Make User Free
        </p>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              setIsLoading(true);
              const payload = {
                email: values.email,
                isFreeUser: true,
              };

              dispatch(editUserTester(payload)).then((res) => {
                setIsLoading(false);
                if (res.type === "editUserTester/fulfilled") {
                  getUserfatch();
                  onClose();
                }
              });
            }}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form className="w-full">
                <div className="mb-4">
                  <InputWithLabel
                    label="Enter Email"
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && errors.email ? errors.email : null}
                    errors={errors.email && touched.email}
                    className={`${
                      errors.email && touched.email
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    } w-full `}
                    errorsText={errors.email}
                  />
                </div>
                <div className="flex justify-end space-x-4 mt-6">
                  <DefaultPrimaryButton
                    type="button"
                    onClick={onClose}
                    value={"cancel"}
                    disabled={isLoading}
                  />
                  <DefaultButton
                    type="submit"
                    value="Continue"
                    disabled={isLoading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default EditUserTester;
